import { List } from "immutable";
import { handleActions } from "redux-actions";
import {
    WHITEBOARD_BOARDS_CLEAR,
    WHITEBOARD_BOARDS_CREATE,
    WHITEBOARD_BOARDS_CREATE_COMPLETED,
    WHITEBOARD_BOARDS_DELETE_COMPLETED,
    WHITEBOARD_BOARDS_FETCH,
    WHITEBOARD_BOARDS_FETCH_COMPLETED,
} from "constants/action-types";

interface IState {
    allBoardsFetched: boolean;
    error?: boolean;
    isCreating?: boolean;
    isFetching: boolean;
    results: List<any>;
}

const initialState: IState = {
    allBoardsFetched: false, // TODO: Is this necessary to prevent more calls to server?
    error: undefined,
    isCreating: false,
    isFetching: false,
    results: undefined,
};

export const whiteboards = handleActions(
    {
        [WHITEBOARD_BOARDS_FETCH]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [WHITEBOARD_BOARDS_FETCH_COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    isFetching: false,
                };
            }

            if (state.results && state.results.isSuperset(payload)) {
                return {
                    ...state,
                    allBoardsFetched: true,
                    isFetching: false,
                };
            }

            return {
                ...state,
                error,
                isFetching: false,
                results: state.results ? (state.results.concat(payload) as List<string>) : List(payload),
            };
        },
        [WHITEBOARD_BOARDS_CLEAR]: (): IState => {
            return {
                allBoardsFetched: false,
                error: undefined,
                isFetching: false,
                results: undefined,
            };
        },
        [WHITEBOARD_BOARDS_CREATE]: (state: IState): IState => {
            return {
                ...state,
                isCreating: true,
            };
        },
        [WHITEBOARD_BOARDS_CREATE_COMPLETED]: (state: IState, { error }: any): IState => {
            return {
                ...state,
                allBoardsFetched: false,
                error,
                isCreating: false,
            };
        },
        [WHITEBOARD_BOARDS_DELETE_COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return { ...state, error };
            }

            if (state.results === undefined) {
                return state;
            }

            const boardToBeRemoved = state.results.indexOf(payload);

            return {
                ...state,
                error,
                results: state.results.delete(boardToBeRemoved),
            };
        },
    },
    initialState,
);
